import Header from '../../../../Components/Header'
import Pick from './Pick'
import { useLocation } from 'react-router-dom';


const AssemblyCreatepick = () => {
      const location = useLocation();  
      const order_id = location.state;

  return (
  <div className='d-flex flex-column' style={{height:'100vh'}}>
       <Header />
       <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <Pick  order_id={order_id} />
       </div>
     </div>
  )
}

export default AssemblyCreatepick